module.exports = __webpack_public_path__ + "static/media/mockPhoto2.593f543b.jpg";